import script from "./OppositesAttract.vue?vue&type=script&setup=true&lang=js"
export * from "./OppositesAttract.vue?vue&type=script&setup=true&lang=js"

import "./OppositesAttract.vue?vue&type=style&index=0&id=21a13f0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a13f0f"]])

export default __exports__